export default {
    isExpandedSidebar(state) {
        return state.sidebar.width >= 180;
    },
    isSmallDesign(state) {
        return state.sidebar.width < 145;
    },
    linkStyleByMenuColor(state, getter) {
        return projectId => {
            return {
                'background-color': state.sidebar.projectId === projectId ? getter.hexToRgba(state.sidebar.menuColor, 0.1) : 'transparent',
            }
        }
    },
    hexToRgba() {
        return (hex, alpha) => {
            let r = parseInt(hex.substring(1, 3), 16);
            let g = parseInt(hex.substring(3, 5), 16);
            let b = parseInt(hex.substring(5, 7), 16);

            r /= 255;
            g /= 255;
            b /= 255;

            return `rgba(${r * 100}%, ${g * 100}%, ${b * 100}%, ${alpha})`;
        }
    },
    currentUserCan(state) {
        return permission => state.sidebar?.user?.permissions && state.sidebar.user.permissions.indexOf(permission) >= 0;
    },
}
